import { getField, updateField } from "vuex-map-fields";
import Repository from "@/repository";

const CONTACT_RENEWAL_API = "/contactRenewal";

// ----------------------- STATE ------------------------- //
const state = {
  contact_renewal_data: [],
  currentIndex: -1
};

// ----------------------- GETTERS ----------------------- //
const getters = {
  getContact_renewal: state =>
    getField(state.contact_renewal_data[state.currentIndex]),

  getCurrentContact_renewal: state => {
    return state.contact_renewal_data[state.currentIndex];
  },
  getContactRenewalReminder: state => vehicleID => {
    return state.contact_renewal_data.filter(item => {
      let index = item.vehicles_id.findIndex(theID => theID == vehicleID);
      return index != -1;
    });
  },
  getOverdue: state => vehicleID => {
    // todo: getOverdue
    let contactReminders = state.contact_renewal_data.filter(item => {
      let index = item.vehicles_id.findIndex(theID => theID == vehicleID);
      return index != -1;
    });
    return contactReminders.length;
  },

  getDueSoon: state => vehicleID => {
    // todo getDueSoon
    let contactReminders = state.contact_renewal_data.filter(item => {
      let index = item.vehicles_id.findIndex(theID => theID == vehicleID);
      return index != -1;
    });
    return contactReminders.length;
  }
};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
  updateContact_renewal(state, payload) {
    updateField(state.contact_renewal_data[state.currentIndex], payload);
  },

  setCurrentIndexByID(state, theID) {
    state.currentIndex = state.contact_renewal_data.findIndex(
      contact_renewal => contact_renewal.id == theID
    );
  },

  loadAllContact_renewals(state, payload) {
    state.contact_renewal_data = payload.data;
    state.currentIndex = 0;
  },

  addContact_renewal(state, payload) {
    state.contact_renewal_data.push(payload.data);
    state.currentIndex = state.contact_renewal_data.length - 1;
  },

  saveContact_renewal(state, payload) {
    state.contact_renewal_data[state.currentIndex] = payload.data;
  },

  fetchContact_renewal(state, payload) {
    if (state.currentIndex == -1) {
      state.contact_renewal_data.push(payload.data);
      state.currentIndex = 0;
    } else {
      state.contact_renewal_data[state.currentIndex] = payload.data;
    }
  },

  fetchByVehicleIDContact_renewal(state, payload) {
    if (payload.data.length > 0) {
      state.contact_renewal_data = payload.data;
      state.currentIndex = -1;
    }
  },

  deleteContact_renewal(state, payload) {
    state.currentIndex = state.contact_renewal_data.findIndex(
      contact_renewal => contact_renewal.id == payload.data.id
    );
    state.contact_renewal_data.splice(state.currentIndex, 1);
  },
  reset(state) {
    state.contact_renewal_data = []
    state.currentIndex = -1
  }
};

// ----------------------- ACTIONS -------------------- //
const actions = {
  async loadAllContact_renewals({ commit }) {
    try {
      commit(
        "loadAllContact_renewals",
        await Repository.get(`${CONTACT_RENEWAL_API}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async addContact_renewal({ commit }) {
    await Repository.get(`${CONTACT_RENEWAL_API}/new`)
      .then(response => {
        commit("addContact_renewal", response);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async saveContact_renewal({ state, commit }) {
    try {
      commit(
        "saveContact_renewal",
        await Repository.post(
          `${CONTACT_RENEWAL_API}`,
          state.contact_renewal_data[state.currentIndex]
        )
      );
    } catch (error) {
      console.log(error);
    }
  },

  async fetchContact_renewal({ commit }, payloadID) {
    try {
      commit(
        "fetchContact_renewal",
        await Repository.get(`${CONTACT_RENEWAL_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async fetchByVehicleIDContact_renewal({ commit }, payloadID) {
    try {
      commit(
        "fetchByVehicleIDContact_renewal",
        await Repository.get(`${CONTACT_RENEWAL_API}/vehicle/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async deleteContact_renewal({ commit }, payloadID) {
    try {
      commit(
        "deleteContact_renewal",
        await Repository.delete(`${CONTACT_RENEWAL_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async searchContact_renewals({ commit }, searchTerm) {
    try {
      commit(
        "loadAllContact_renewals",
        await Repository.get(`${CONTACT_RENEWAL_API}/search?q=${searchTerm}`)
      );
    } catch (error) {
      console.log(error);
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
